import React from "react";

const SideBarMenu = ({
  sectionData,
  onSectionClick,
  selectedSection,
  selectedRole,
  className
}) => {
  return (
    <div className={`container-fluid h-100 ${className}`}>
      <div className="row h-100">
        <div className="bg-white rounded p-4 min-vh-100 d-flex justify-content-between flex-column">
          <div>
            <a className="text-decoration-none text-black d-flex align-items-center ms-3 mt-2">
              <span className="ms-1 fs-4">Documentation</span>
            </a>
            <hr className="bg-black" />
            <ul className="nav nav-pills flex-column">
              {sectionData
                ?.filter((section) => section.role.find((role) => role === selectedRole) === selectedRole)
                .map((heading, index) => (
                  <li
                    key={index}
                    className={`nav-item text-white fs-4 my-1 ${
                      selectedSection === index ? "sidebar-doc-active" : ""
                    }`}
                    onClick={() => onSectionClick(index)}
                  >
                    <a
                      href="#"
                      className={`nav-link ${
                        selectedSection === index ? "text-white" : "text-black"
                      } fs-5`}
                    >
                      <span className="ms-2">{heading.section}</span>
                    </a>
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideBarMenu;
